module.exports = __webpack_public_path__ + "static/media/instakolor.78a8bae3.svg";